export default {
  title: 'Punti e sconti',
  store_credit: 'Credito negozio',
  points_balance: 'Saldo punti',
};
